import { getEnv } from 'utils/env'
import { VoucherBannerVariant } from './VoucherBanner.types'

// Standard-flow campaign for Segment and Apollo; set per tenant and environment in .env-cmdrc.
export const getVoucherCampaignId = () =>
  getEnv('REACT_APP_VOUCHER_CAMPAIGN_ID', true)

export const VOUCHER_ACTIVATION_BANNER_ID = 'voucher-activation-banner'

export const RCE_VOUCHER_CAMPAIGN_ID = '43b0c607-9a79-48b1-8074-a192daadb603'

export const RCE_VOUCHER_ACTIVATED_NOTICE_PAGES: ReadonlyArray<string> = [
  'editPage_additional',
  'edit_dac'
]

export const VOUCHER_TERMS_URL: Record<VoucherBannerVariant, string> = {
  smava: 'https://legal-docs.smava.de/voucherTerms.pdf',
  ffg: 'https://legal-docs.finanzcheck.de/voucherTerms.pdf'
}

export const VOUCHER_ACTIVATED_TITLE = (amount: number | null) => {
  return amount != null
    ? `Ihr ${amount} € Gutschein ist aktiviert!`
    : 'Ihr Gutschein ist aktiviert!'
}
